import { Button, Input } from "@app/ui";
import { useState } from "react";

import { useI18n } from "../../lib/useI18n.js";

/** Name input + Add button shared by all three Organize panels. */
export function AddEntityRow({ placeholder, onAdd }: { placeholder: string; onAdd: (name: string) => Promise<void> | void }) {
  const { t } = useI18n();
  const [name, setName] = useState("");

  async function handleAdd() {
    const trimmed = name.trim();
    if (!trimmed) return;
    await onAdd(trimmed);
    setName("");
  }

  return (
    <div className="mt-3 flex gap-2">
      <Input
        value={name}
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => { if (event.key === "Enter") void handleAdd(); }}
        placeholder={placeholder}
      />
      <Button onClick={() => void handleAdd()}>{t("common.add")}</Button>
    </div>
  );
}
